<script setup lang="ts">
import type { PropType } from "vue";

defineProps({
  heading: {
    type: String as PropType<string>,
    required: true,
  },
});
</script>

<template>
  <fieldset class="form--fieldset">
    <legend class="pfr-fieldset--legend">
      {{ heading }}
    </legend>
    <slot />
  </fieldset>
</template>

<style>
.pfr-fieldset--legend {
  margin-block-end: var(--spacing-16);
  font-weight: 700;
}
</style>
